import type { Building } from "building-types/building/buildingTypes";
import objectIsEmpty from "common/utils/objectIsEmpty";

export function buildingIsEmpty(building: Pick<Building, "rooms">): boolean {
  return !building || objectIsEmpty(building.rooms);
}
